import React, { useEffect, useMemo } from 'react';
import { useIsRequiredElement } from '../../../hook/useIsRequiredElement';
import ElementErrorMessage from './components/element-error-message';
import { GridYUnit, GridYValue } from '../../../constants';
import { useIsInitFormPage } from '../../../hook/pages/useIsInitFormPage';
import cx from 'classnames';
import { isMobile, isTablet } from 'react-device-detect';
import { replaceValuesInText } from '../../../utility';

export const SingleLineElement = function FromElement({
  element,
  handlerChange,
  error,
  formHasOnlyOneSubmitter,
  previewTabItem,
  isPrint,
  autoFillingVariables,
}) {
  const isRequiredElement = useIsRequiredElement(element, formHasOnlyOneSubmitter);
  // With the label on the left it belongs to a fixed column the constructor
  // also draws, so the width comes from the stylesheet. Above the input it
  // still hugs its own text.
  const labelPlacementLeft = element.options.labelPlacement === 'left';
  const isInitFormPage = useIsInitFormPage();

  useEffect(() => {
    if (isInitFormPage) return;
    // handlerChange(element, replaceValuesInText(element.options.valueInput.trimStart(), autoFillingVariables, submitterType, submitterInfo));
  }, []);

  const cleanValue = useMemo(() => {
    if (isPrint) {
      return replaceValuesInText(element.options.valueInput, autoFillingVariables, 'skip', 'skip', true);
    }
    return element.options.valueInput;
  }, [isPrint, element.options.valueInput]);

  return (
    <div
      className={cx('form-element-flex-label-wrapper', {
        labelPlacementLeft,
        isMobile: isMobile || previewTabItem === 'phone',
        isTablet: isTablet || previewTabItem === 'tablet',
      })}
    >
      <label
        htmlFor={element.id}
        className="form-label"
        style={{
          zIndex: 5000 + (element.options.zIndex || 10),
          ...(labelPlacementLeft ? {} : { width: 'fit-content' }),
          position: 'relative',
        }}
      >
        {element.options.label} <span className="required">{isRequiredElement ? '*' : ''}</span>
      </label>
      <div>
        <input
          value={cleanValue}
          onChange={(e) => handlerChange(element, e.target.value)}
          name={element.options.name}
          readOnly={element.options.readOnly || (element.options.filledByCreator && !element.options.initiatorCanEdit)}
          id={element.id}
          type="text"
          style={{
            height: element.options.innerElemHeight * GridYValue + GridYUnit,
            zIndex: 5000 + (element.options.zIndex || 10),
            position: 'relative',
            width: '100%',
            minHeight: 'unset',
          }}
          className={`form-control form-control-${element.options.size}`}
        />
      </div>
      <ElementErrorMessage message={error} />
      {element.options.instructions && <p className="instructions">{element.options.instructions}</p>}
    </div>
  );
};
